/* eslint-disable @typescript-eslint/no-explicit-any */

import { getPageBySlug } from "./use-page-by-slug";

import type { AppRouter } from "@byko/lib-api-dato-ssr";
import type { TRPCClient } from "@trpc/react";
import type { NextPageContext } from "next/types";
import type { QueryClient } from "react-query";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const withDatoPageBySlug = (component: any) => {
  const oldFn = component.getInitialProps ?? null;
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  component.getInitialProps = async (
    context: NextPageContext & { queryClient?: QueryClient; trpcClient: TRPCClient<AppRouter> },
  ) => {
    const value = oldFn ? await oldFn(context) : {};
    const { res } = context;
    const slug = Array.isArray(context.query["slug"]) ? context.query["slug"].join("/") : context.query["slug"];
    if (!slug || Array.isArray(slug)) {
      if (context.res) {
        if (res) {
          res.statusCode = 500;
        }
      }
      return {
        slug: "INVALID SLUG",
        notFound: false,
        internalError: true,
      };
    }
    try {
      const data = await getPageBySlug("/api/cms", undefined, true, context)(slug);
      if ("error" in data) {
        const { notFound, internalError } = data.error;
        if (res) {
          res.statusCode = notFound ? 404 : 500;
        }
        return {
          ...value,
          slug,
          notFound,
          internalError,
        };
      }
      return {
        ...value,
        slug,
        data,
        internalError: false,
        notFound: false,
      };
    } catch (_e) {
      console.error(_e);
      return {
        ...value,
        slug,
        internalError: true,
        notFound: false,
      };
    }
  };
  return component;
};
